import { jsxs, jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import 'react';
import { FiBell } from 'react-icons/fi';
import { IoMdCalendar } from 'react-icons/io';

const Item = (props) => {
  const {
    notification
  } = props;
  return /* @__PURE__ */ jsxs("div", { className: clsx("hover:bg-secondary-light rounded-micro m-mili", {
    "hover:cursor-pointer": notification.link
  }), onClick: () => {
    if (notification.link) {
      window.open(notification.link, "_self");
    }
  }, children: [
    /* @__PURE__ */ jsxs("div", { className: "p-mili", children: [
      /* @__PURE__ */ jsx("p", { className: "text-base font-bold text-secondary-xdark", children: notification.titulo }),
      /* @__PURE__ */ jsx("p", { className: "text-sub text-secondary-xdark", dangerouslySetInnerHTML: {
        __html: notification.texto
      } })
    ] }),
    /* @__PURE__ */ jsxs("div", { className: "flex justify-between px-mili py-micro", children: [
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-micro text-secondary-medium", children: [
        /* @__PURE__ */ jsx(IoMdCalendar, {}),
        /* @__PURE__ */ jsx("p", { className: "text-sub", children: notification.data })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-x-micro text-secondary-medium", children: [
        /* @__PURE__ */ jsx(FiBell, {}),
        /* @__PURE__ */ jsx("p", { className: "text-sub ", children: notification.produto })
      ] })
    ] })
  ] });
};

export { Item };
